import { Box, Stepper, Step, styled } from "@mui/material";

export const Wrapper = styled(Box)`
  padding: 2rem 0;
  width: 100%;
  height: 539px;
  margin: auto;
  text-align: center;
  background-color: #f4f7fa;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 768px) {
    height: 100%;
  }
`;

export const InnerContainer = styled(Box)`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 0 20px;

  @media screen and (max-width: 900px) {
    width: 100%;
    padding: 12px;
  }
`;

export const SearchWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: normal;
  gap: 1rem;
  margin: 1.5rem;
  background-color: white;

  @media screen and (max-width: 900px) {
    width: 100%;
    flex-direction: column;

    & > div {
      width: 100% !important;
    }
  }

  div {
    height: 100%;
  }

  input {
    padding: 14px;
  }
`;

export const StepLine = styled("span")`
  height: 4px;
  background-color: #087e38;
  display: inline-block;
  width: 92%;
  position: absolute;
  z-index: 1;
  top: 10px;
  right: 54%;

  @media screen and (max-width: 768px) {
    width: 4px;
    height: 58px;
    top: -41px;
    right: 0;
    left: 18px;
  }
`;

export const StepperWrapper = styled(Stepper)`
  width: 100%;
  margin: 40px 0 20px;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
`;

export const StepWrapper = styled(Step)`
  & > span span:last-child {
    text-align: center;
  }

  @media screen and (max-width: 768px) {
    width: 240px;
    & > span {
      flex-direction: row !important;
      gap: 10px;

      span:last-child {
        text-align: left;
      }
    }
  }
`;
